import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss'],
})
export class ExploreComponent implements OnInit, OnDestroy {
  @Input() links: string[];
  @Input() images: string[];
  @Input() headers: string[];
  @Input() text: string[];
  @Input() alignRight: boolean[];

  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {}
}
